module.exports = __webpack_public_path__ + "static/media/presupuesto.7f51092d.PNG";